import React, { useEffect, useState } from 'react';
import moment from 'moment';

import AdminSearch from '../components/AdminSearch';
import Header from '../components/Header';
import MemberTable from '../components/MemberTable';

const AdminClubMembers = ({ user, onLogout }) => {
  const [loading, setLoading] = useState(true);
  const [originalResults, setOriginalResults] = useState([]);
  const [members, setMembers] = useState([]);
  const [dataError, setDataError] = useState('');

  useEffect(() => {
    getMemberships();
  }, [])

  const getMemberships = () => {
    setLoading(true);
    setDataError('');

    fetch("/api/vehicles")
      .then(res => res.json())
      .then(
        (result) => {
          mapResults(result, 'false')
          setLoading(false)
        },
        (error) => {
          console.log(error)
          setDataError('There was a problem loading data.')
          setLoading(false)
        }
    )
  }

  const onSearchUsers = (member, vehicle, onlyActive) => {
    // prevent users from spamming, only call API if not already loading
    if (!loading) {
      setLoading(true);
      setDataError('');

      // let url = new URL(`${window.location.href.replace('/admin/members', '')}/api/vehicles/search`);
      // url.search = new URLSearchParams({
      //   member: member || 'none',
      //   vehicle: vehicle || 'none',
      //   onlyActive
      // })

      // fetch(url)
      //   .then(res => res.json())
      //   .then(
      //     (result) => {
      //       mapResults(result, onlyActive)
      //       setLoading(false)
      //     },
      //     (error) => {
      //       console.log(error)
      //       setDataError('There was a problem loading data.')
      //       setLoading(false)
      //     }
      // )

      let _filter = [...originalResults];
      if (onlyActive && onlyActive !== 'false') {
        _filter = _filter.filter(r => r.status === 'ACTIVE')
      }

      if (vehicle) {
        _filter = _filter.filter(r => r.year === vehicle || r.make === vehicle || r.model === vehicle)
      }

      if (member) {
        _filter = _filter.filter(r => r.memberFirstName === member || r.memberLastName === member)
      }

      setMembers(_filter)
      setLoading(false)
    }
  }

  const mapResults = (result, onlyActive) => {
    const mappedResults = result.map(r => {
      if (r) {
        return {
          memberNumber: r.memberNumber,
          status: r.status && moment().isBefore(r.subscription.expirationDate) ? r.status : !r.subscription ? 'UNASSIGNED' : moment().isBefore(r.subscription.expirationDate) ? 'ACTIVE' : 'EXPIRED',
          startDate: !r.subscription ? 'N/A' : moment(r.subscription.startDate).format('MM/DD/YYYY'),
          expirationDate: !r.subscription ? 'N/A' : moment(r.subscription.expirationDate).format('MM/DD/YYYY'),
          memberFirstName: r.user.firstName,
          memberLastName: r.user.lastName,
          memberName: `${r.user.prefix} ${r.user.lastName}`,
          year: r.year,
          make: parseMake(r.make),
          model: r.model,
          licensePlate: r.licensePlate,
          color: r.color,
          email: r.user.email
        }
      }
    }).filter(r => r)

    setOriginalResults(mappedResults)
    setMembers(mappedResults)
  }

  const parseMake = (make) => {
    if (make === 'Volkswagen') {
      return 'VW'
    }
    return make;
  }

  return (
    <div>
      <Header user={user} onLogout={onLogout}></Header>
      <AdminSearch searchUsers={onSearchUsers}></AdminSearch>
      <MemberTable members={members} loading={loading} dataError={dataError}></MemberTable>
    </div>
  )
}

export default AdminClubMembers